import {
  //
  LIST_SAFEGUARDING_REVIEWS,
  LIST_SAFEGUARDING_REVIEWS_SUCCESS,
  LIST_SAFEGUARDING_REVIEWS_FAILURE,
  //
  LIST_SAFEGUARDING_CASES,
  LIST_SAFEGUARDING_CASES_SUCCESS,
  LIST_SAFEGUARDING_CASES_FAILURE,
  //
  LIST_SAFEGUARDING_HISTORY,
  LIST_SAFEGUARDING_HISTORY_SUCCESS,
  LIST_SAFEGUARDING_HISTORY_FAILURE,
  //
  GET_SAFEGUARDING_REVIEW,
  GET_SAFEGUARDING_REVIEW_SUCCESS,
  GET_SAFEGUARDING_REVIEW_FAILURE,
  //
  CREATE_SAFEGUARDING_REVIEW,
  CREATE_SAFEGUARDING_REVIEW_SUCCESS,
  CREATE_SAFEGUARDING_REVIEW_FAILURE,
  //
  PATCH_SAFEGUARDING_REVIEW,
  PATCH_SAFEGUARDING_REVIEW_SUCCESS,
  PATCH_SAFEGUARDING_REVIEW_FAILURE,
  //
  ADD_SAFEGUARDING_NOTIFICATION,
  ADD_SAFEGUARDING_NOTIFICATION_SUCCESS,
  ADD_SAFEGUARDING_NOTIFICATION_FAILURE,
  //
  LINK_SAFEGUARDING_RECORD,
  LINK_SAFEGUARDING_RECORD_SUCCESS,
  LINK_SAFEGUARDING_RECORD_FAILURE,
  //
  RESOLVE_SAFEGUARDING_REVIEW,
  RESOLVE_SAFEGUARDING_REVIEW_SUCCESS,
  RESOLVE_SAFEGUARDING_REVIEW_FAILURE,
  //
  LIST_LINKABLE_INCIDENTS,
  LIST_LINKABLE_INCIDENTS_SUCCESS,
  LIST_LINKABLE_INCIDENTS_FAILURE,
  //
  LINK_SAFEGUARDING_INCIDENT,
  LINK_SAFEGUARDING_INCIDENT_SUCCESS,
  LINK_SAFEGUARDING_INCIDENT_FAILURE,
  //
  UNLINK_SAFEGUARDING_INCIDENT,
  UNLINK_SAFEGUARDING_INCIDENT_SUCCESS,
  UNLINK_SAFEGUARDING_INCIDENT_FAILURE,
  //
  GET_SAFEGUARDING_CASE,
  GET_SAFEGUARDING_CASE_SUCCESS,
  GET_SAFEGUARDING_CASE_FAILURE,
} from "./constants";

// List the resident's cases — payload: { residentId }
export const listSafeguardingReviews = (payload, onSuccess) => ({
  type: LIST_SAFEGUARDING_REVIEWS,
  payload,
  onSuccess,
});
export const listSafeguardingReviewsSuccess = (payload) => ({
  type: LIST_SAFEGUARDING_REVIEWS_SUCCESS,
  payload,
});
export const listSafeguardingReviewsFailure = (payload) => ({
  type: LIST_SAFEGUARDING_REVIEWS_FAILURE,
  payload,
});

// List open case references in the location — payload: { residentId }
export const listSafeguardingCases = (payload, onSuccess) => ({
  type: LIST_SAFEGUARDING_CASES,
  payload,
  onSuccess,
});
export const listSafeguardingCasesSuccess = (payload) => ({
  type: LIST_SAFEGUARDING_CASES_SUCCESS,
  payload,
});
export const listSafeguardingCasesFailure = (payload) => ({
  type: LIST_SAFEGUARDING_CASES_FAILURE,
  payload,
});

// List this resident's safeguarding history — payload: { residentId, excludeReviewUuid?, excludeGovernanceUuid? }
export const listSafeguardingHistory = (payload, onSuccess) => ({
  type: LIST_SAFEGUARDING_HISTORY,
  payload,
  onSuccess,
});
export const listSafeguardingHistorySuccess = (payload) => ({
  type: LIST_SAFEGUARDING_HISTORY_SUCCESS,
  payload,
});
export const listSafeguardingHistoryFailure = (payload) => ({
  type: LIST_SAFEGUARDING_HISTORY_FAILURE,
  payload,
});

// Get — payload: { residentId, uuid }
export const getSafeguardingReview = (payload, onSuccess) => ({
  type: GET_SAFEGUARDING_REVIEW,
  payload,
  onSuccess,
});
export const getSafeguardingReviewSuccess = (payload) => ({
  type: GET_SAFEGUARDING_REVIEW_SUCCESS,
  payload,
});
export const getSafeguardingReviewFailure = (payload) => ({
  type: GET_SAFEGUARDING_REVIEW_FAILURE,
  payload,
});

// Create (from an alert) — payload: { residentId, formData }
export const createSafeguardingReview = (payload, onSuccess) => ({
  type: CREATE_SAFEGUARDING_REVIEW,
  payload,
  onSuccess,
});
export const createSafeguardingReviewSuccess = (payload) => ({
  type: CREATE_SAFEGUARDING_REVIEW_SUCCESS,
  payload,
});
export const createSafeguardingReviewFailure = (payload) => ({
  type: CREATE_SAFEGUARDING_REVIEW_FAILURE,
  payload,
});

// Patch a step — payload: { residentId, uuid, formData }
export const patchSafeguardingReview = (payload, onSuccess) => ({
  type: PATCH_SAFEGUARDING_REVIEW,
  payload,
  onSuccess,
});
export const patchSafeguardingReviewSuccess = (payload) => ({
  type: PATCH_SAFEGUARDING_REVIEW_SUCCESS,
  payload,
});
export const patchSafeguardingReviewFailure = (payload) => ({
  type: PATCH_SAFEGUARDING_REVIEW_FAILURE,
  payload,
});

// Add a statutory notification — payload: { residentId, uuid, formData }
export const addSafeguardingNotification = (payload, onSuccess) => ({
  type: ADD_SAFEGUARDING_NOTIFICATION,
  payload,
  onSuccess,
});
export const addSafeguardingNotificationSuccess = (payload) => ({
  type: ADD_SAFEGUARDING_NOTIFICATION_SUCCESS,
  payload,
});
export const addSafeguardingNotificationFailure = (payload) => ({
  type: ADD_SAFEGUARDING_NOTIFICATION_FAILURE,
  payload,
});

// Link (instantiate) a risk-assessment / care-plan / MCA / DoLS record —
// payload: { residentId, uuid, formData }
export const linkSafeguardingRecord = (payload, onSuccess) => ({
  type: LINK_SAFEGUARDING_RECORD,
  payload,
  onSuccess,
});
export const linkSafeguardingRecordSuccess = (payload) => ({
  type: LINK_SAFEGUARDING_RECORD_SUCCESS,
  payload,
});
export const linkSafeguardingRecordFailure = (payload) => ({
  type: LINK_SAFEGUARDING_RECORD_FAILURE,
  payload,
});

// Resolve — payload: { residentId, uuid, formData }
export const resolveSafeguardingReview = (payload, onSuccess) => ({
  type: RESOLVE_SAFEGUARDING_REVIEW,
  payload,
  onSuccess,
});
export const resolveSafeguardingReviewSuccess = (payload) => ({
  type: RESOLVE_SAFEGUARDING_REVIEW_SUCCESS,
  payload,
});
export const resolveSafeguardingReviewFailure = (payload) => ({
  type: RESOLVE_SAFEGUARDING_REVIEW_FAILURE,
  payload,
});

// List the incident records that may still be linked to this review —
// payload: { residentId, uuid }
export const listLinkableIncidents = (payload, onSuccess) => ({
  type: LIST_LINKABLE_INCIDENTS,
  payload,
  onSuccess,
});
export const listLinkableIncidentsSuccess = (payload) => ({
  type: LIST_LINKABLE_INCIDENTS_SUCCESS,
  payload,
});
export const listLinkableIncidentsFailure = (payload) => ({
  type: LIST_LINKABLE_INCIDENTS_FAILURE,
  payload,
});

// Attach an incident record to this review —
// payload: { residentId, uuid, incidentUuid, linkNote? }. `onError(message)`
// receives the api's own 422 text (different resident / already linked
// elsewhere), which is meaningful and must reach the user verbatim.
export const linkSafeguardingIncident = (payload, onSuccess, onError) => ({
  type: LINK_SAFEGUARDING_INCIDENT,
  payload,
  onSuccess,
  onError,
});
export const linkSafeguardingIncidentSuccess = (payload) => ({
  type: LINK_SAFEGUARDING_INCIDENT_SUCCESS,
  payload,
});
export const linkSafeguardingIncidentFailure = (payload) => ({
  type: LINK_SAFEGUARDING_INCIDENT_FAILURE,
  payload,
});

// Detach an incident record — payload: { residentId, uuid, incidentUuid }.
// The api 422s on the originating incident; `onError(message)` surfaces it.
export const unlinkSafeguardingIncident = (payload, onSuccess, onError) => ({
  type: UNLINK_SAFEGUARDING_INCIDENT,
  payload,
  onSuccess,
  onError,
});
export const unlinkSafeguardingIncidentSuccess = (payload) => ({
  type: UNLINK_SAFEGUARDING_INCIDENT_SUCCESS,
  payload,
});
export const unlinkSafeguardingIncidentFailure = (payload) => ({
  type: UNLINK_SAFEGUARDING_INCIDENT_FAILURE,
  payload,
});

// One event, several residents — every review + incident sharing a case
// reference. payload: { residentId, reference }
export const getSafeguardingCase = (payload, onSuccess, onError) => ({
  type: GET_SAFEGUARDING_CASE,
  payload,
  onSuccess,
  onError,
});
export const getSafeguardingCaseSuccess = (payload) => ({
  type: GET_SAFEGUARDING_CASE_SUCCESS,
  payload,
});
export const getSafeguardingCaseFailure = (payload) => ({
  type: GET_SAFEGUARDING_CASE_FAILURE,
  payload,
});
